<script>
export default {
  props: {
    img: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    money: {
      type: Object,
      default: () => {
        return {}
      }
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    starList: {
      type: Array,
      default: () => {
        return []
      }
    },
    to: {
      type: String,
      default: 'contact'
    },
    isShowContact: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
}
</script>

<template>
  <div :class="$style.basePlan" class="h-100">
    <!-- <router-link :to="{ name: `${to}` }" class="h-100 basePlan__Inner d-flex flex-column text-decoration-none color-text-1"></router-link> -->
    <router-link :to="{ name: 'contact' }" class="h-100 basePlan__Inner d-flex flex-column text-decoration-none color-text-1">
      <img :src="img" alt="" class="basePlan__img">
      <h3 class="basePlan__title">{{title}}</h3>
      <div class="basePlan__money"> <span class="money font-josefin">{{money.money}}</span><span v-if="money.count" class="count ml-2">{{money.count}}</span></div>
      <ul 
        
        class="basePlan__list list-unstyled"
      >
        <template v-if="list.length">
          <li 
            v-for="(item,$index) in list"
            :key="$index"
            class="basePlan__item d-flex"
          >
            <i class="icon icomoon icon-check"></i>
            <span v-html="item"></span>
          </li>
        </template>
        <template v-if="starList.length">
          <li 
            v-for="(item, $index2) in starList"
            :key="`starList-${$index2}`"
            class="basePlan__item d-flex"
          >
            <i class="fas fa-star color-primary fa-sm pr-1" style="position: relative; top: 4px;"></i>
            <span v-html="item"></span>
          </li>
        </template>
      </ul>
      <div class="basePlan__link">
        <BaseButton
          v-if="isShowContact"
          :to="{ name: 'contact' }" class="isStylePrimary isFull isSmallRadious"
        >
          專人聯繫
        </BaseButton>
        <!-- <BaseButton
          v-if="to !== 'contact'"
          :to="{ name: `${to}` }" class="isStyleBorder mt-4 isFull "
        >
          詳細內容
        </BaseButton> -->

      </div>
    </router-link>
  </div>
</template>
<style lang="scss" module>
  .basePlan {
    :global {
      .basePlan {
        &__Inner {
          background: #FFFFFF;
          border: 2px solid #EDF0F4;
          border-radius: 20px;
          padding: 0 1.5rem 40px 1.5rem;
          transition: .3s;
          &:hover {
            transform: translateY(-15px);
            border: 2px solid $color-primary;
          }
        }
        &__title {
          margin-top: -60px;
          font-size: 20px;
          font-weight: 600;
          color: $color-text-1;
          @include max-md {
            font-size: 16px;
          }
        }
        &__money {
          color: #777777;
          .money {
            font-size: 1.9rem;
            color: $color-text-1;
            // margin-right: 14px;
            @include max-md {
              font-size: 1.5rem;
            }
          }
          .count {
            padding-top: 10px;
            @include max-md {
              font-size: 14px;
            }
          }
        }
        &__img {
          position: relative;
          top: -70px;
        }
        &__list {
          margin-top: 24px;
          margin-bottom: 30px;
          padding-top: 30px;
          border-top: 1px solid $color-line;
          min-height: 350px;
        }
        &__item {
          color: $color-text-2;
          @include max-md {
            font-size: 14px;
          }
          &:not(:first-child) {
            margin-top: 16px;
          }
          .icon {
            font-size: 14px;
            color: $color-primary;
            padding-top: 7px;
            padding-right: 5px;
          }
        }
        &__link {
          margin-top: auto;
        }
      }
    }
  }
</style>